import Box from 'components/Box/Box';

export default Box;
